/**
 * The declarations somebody signs to register a work.
 *
 * ## PLACEHOLDER WORDING, and it must keep reading as one
 *
 * This is legal text attached to an act that creates a permanent registry
 * record. It needs sign-off before it ships, and it should not be edited in a
 * pull request without that.
 *
 * ## Why it lives here rather than in a client
 *
 * It was written for the web's registration wizard and lived there. The moment
 * a second client had to show the same four sentences, keeping it in one of
 * them became a drift waiting to happen — and of everything in this product,
 * the text somebody signs is the worst thing to have two slightly different
 * versions of. A collector who ticks four boxes on a phone must be agreeing to
 * exactly what a collector ticking four boxes in a browser agreed to.
 *
 * So it is vocabulary, which is what this package is for.
 *
 * The wording itself describes what is actually true of the registry, after the
 * review step was removed: there is nobody to accept the decision of, nobody to
 * share a submission with, and no authentication to accept as final. What
 * replaces those is the thing that IS true — the record is yours, it is public
 * to whoever you show it to, and what it is worth is what other people will put
 * their name to.
 */
export const DECLARATIONS = [
    {
        key: "true",
        label: "I confirm that the information provided is true, accurate and complete to the best of my knowledge. I understand that submitting false or misleading information may constitute fraud.",
    },
    {
        key: "right",
        label: "I am submitting this registration in good faith as the current owner or an authorised representative of the owner, and I have made reasonable efforts to verify the provenance provided.",
    },
    {
        key: "authority",
        label: "I understand that ONDO does not authenticate this work. Registering it records my claim; whether anyone believes it is a matter of who is willing to verify its provenance, and ONDO neither vouches for that nor arbitrates it.",
    },
    {
        key: "advice",
        label: "I acknowledge that I have had the opportunity to take independent legal advice on this registration, and I choose to proceed.",
    },
];
/**
 * The warning shown beside them.
 *
 * Separate from the declarations because it is not something anybody agrees to
 * — it is the registry saying what it will do.
 */
export const FRAUD_WARNING = "Registering false or misleading information about an artwork is a serious offence. " +
    "Fraudulent registrations may result in permanent account suspension and legal action.";
/**
 * The two views every registration is expected to carry.
 *
 * **Expected, not enforced.** A registration with neither is accepted: an
 * authority asking for a photograph is a conversation, not a form error. These
 * drive what a capture flow says is still outstanding, and nothing else.
 */
export const CORE_VIEWS = ["front", "back"];
/**
 * The views a collector can add beyond the core two.
 *
 * `detail` and `other` carry a free-text label, which is how a view the
 * vocabulary has no word for — "Texture", say — gets named without the
 * vocabulary having to grow a word for it.
 */
export const ADDITIONAL_VIEWS = [
    "signature",
    "stamp",
    "gallery_label",
    "edition_number",
    "certificate",
    "detail",
];
//# sourceMappingURL=registration.js.map